import { useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useEventNameConstructor, useModal, useSendEvents } from '@hooks'
import { EVENTS } from '@constants'
import { Button } from '@components'
import { getAppLink } from '@utils'
import * as S from './styled'

const HamburgerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 12H21M3 6H21M3 18H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export function UserMenu({ screenId, defaultState }: { screenId: string, defaultState?: boolean }) {
  const { t } = useTranslation()
  const sendEvent = useSendEvents({ screenId })
  const getEventName = useEventNameConstructor({ screenId })
  const ref = useRef<HTMLDivElement>(null)
  const popup = useModal()
  const onMenuButtonClick = () => {
    sendEvent(getEventName(EVENTS.CLICK), { [EVENTS.BC]: 'menu toggle open' })
    popup.toggle()
  }
  const onLoginButtonClick = () => {
    sendEvent(getEventName(EVENTS.CLICK), { [EVENTS.BC]: 'log in' })
    popup.toggle()
    window.location.href = getAppLink()
  }
  const defaultStyles = defaultState ? {
    backgroundColor: '#CCD6E0',
    color: '#283845',
  } : {}

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) popup.close()
    }
    if (popup.isOpen) document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [popup])

  return (
    <>
      <S.DesktopWrapper>
        <Button
          id={'log-in-button-desktop'}
          onClick={onLoginButtonClick}
          style={{ minWidth: 150, paddingBlock: 8, height: 'auto', ...defaultStyles }}
        >
          {t('log_in')}
        </Button>
      </S.DesktopWrapper>
      <S.Wrapper ref={ref}>
        <S.MenuButton id={'user-menu-button'} onClick={onMenuButtonClick}>
          <HamburgerIcon />
        </S.MenuButton>
        <S.Dropdown id={'menu-popup'} $open={popup.isOpen}>
          <Button
            id={'log-in-button-mobile'}
            onClick={onLoginButtonClick}
            style={defaultStyles}
          >
            {t('log_in')}
          </Button>
        </S.Dropdown>
      </S.Wrapper>
    </>
  )
}
